import AppTableau from './tableau';
import Chart from 'chart.js/auto';
import * as localforage from "localforage";
import Picker from 'vanilla-picker/csp'

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

window.Picker = Picker;
window.localforage = localforage;
window.moment = require('moment');
window.Chart = Chart;
window.AppTableau = AppTableau;
window.AppLocale = document.documentElement.lang;

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  window.toastr = require('toastr');
  require('overlayscrollbars');
  require('../../public/vendor/adminlte/dist/js/adminlte');
  require('datatables.net');
  require('datatables.net-bs4');
  require('bootstrap');
  require('select2/dist/js/select2.full');
  require('daterangepicker')
  require('passwordruleshelper/dist/js/passwordRulesHelper');
  require('bootstrap-duallistbox/dist/jquery.bootstrap-duallistbox.min');
  require('bootstrap-fileinput');
  require('bootstrap-fileinput/themes/fas/theme.min');
  require('bootstrap-fileinput/js/locales/fr.js');
  require('bootstrap-tagsinput/dist/bootstrap-tagsinput');
  require('bootstrap-switch');
  require('inputmask/dist/jquery.inputmask');
  require('bootstrap-maxlength');
  require('jquery.steps');
  require('treetables');
  require('./tableau-search');

  /**
   * Requiring Jquery-Validation after DOM is fully Load to avoid
   * conflict with Bootstrap Tags-input.
   */
  jQuery(() => {
    require('jquery-validation');
  });

  require('./forms');
  require('./users');
  require('./creatives');
  require('./ids-products-tooltip-helper');
  require('./campaigns-index');
  require('./product-ranges-create');
  require('./product-ranges-edit');
  require('./audits-index');
  require('./authcheck');
  require('./notifications');
  require('./notifications');
  require('./line-item-product-catalog');
  require('./product-personalized-report');
  require('./product-personalized-report-edit');

} catch (e) {
  console.error(e);
}
